/**
 * ¿Esta sesión corre en una vista previa de Vercel?
 *
 * Las vistas previas comparten la base de datos de PRODUCCIÓN. Por eso el servicio de propuestas de
 * agentes se niega a escribir (proponer, aprobar, rechazar, aplicar) cuando esto devuelve true: no basta
 * con ocultar el botón.
 *
 * Señales (basta UNA para considerarla vista previa — ante contradicción se elige el lado seguro):
 *  1. VERCEL_ENV = 'preview' (en el navegador solo existe como VITE_VERCEL_ENV si en Vercel está activada
 *     "Automatically expose System Environment Variables"; en Node, process.env.VERCEL_ENV).
 *  2. El hostname termina en `.vercel.app` y no es el alias de producción (las vistas previas se sirven en
 *     <proyecto>-git-<rama>-<equipo>.vercel.app o <proyecto>-<hash>-<equipo>.vercel.app).
 * La señal 2 funciona aunque la variable de entorno no esté expuesta.
 */

/** Hosts de producción: nunca se tratan como vista previa. */
export const HOSTS_PRODUCCION: ReadonlySet<string> = new Set([
  'app.tryquipus.com',
  'tryquipus.com',
  'www.tryquipus.com',
  'quipus-dashboard.vercel.app',
]);

export interface EntornoVistaPrevia {
  vercelEnv?: string | null;
  hostname?: string | null;
}

function vercelEnvActual(): string | undefined {
  const viteEnv = (import.meta.env as Record<string, string | undefined>).VITE_VERCEL_ENV;
  if (viteEnv) return viteEnv;
  return typeof process !== 'undefined' ? process.env?.VERCEL_ENV : undefined;
}

export function esVistaPrevia(entorno: EntornoVistaPrevia = {}): boolean {
  const vercelEnv = (entorno.vercelEnv !== undefined ? entorno.vercelEnv : vercelEnvActual()) ?? '';
  if (vercelEnv.trim().toLowerCase() === 'preview') return true;

  const hostname = (
    entorno.hostname !== undefined ? entorno.hostname : globalThis.location?.hostname
  ) ?? '';
  const host = hostname.trim().toLowerCase();
  return host.endsWith('.vercel.app') && !HOSTS_PRODUCCION.has(host);
}

export const MSG_VISTA_PREVIA = 'Vista previa: no escribe';

/** Explicación para el banner (la vista previa comparte la base de datos de producción). */
export const MSG_VISTA_PREVIA_DETALLE =
  'Esta versión comparte la base de datos de producción: puedes mirar, pero proponer, aprobar y rechazar están desactivados.';

/** Se lanza al intentar escribir desde una vista previa. */
export class VistaPreviaError extends Error {
  constructor() {
    super(MSG_VISTA_PREVIA);
    this.name = 'VistaPreviaError';
  }
}
